import React from 'react';
import { PROCOGIA_COLORS, getCardStyles, getTextStyles, getIconColor } from '../utils/themeUtils';

const ThemedCard = ({ 
  title, 
  subtitle, 
  value, 
  icon: Icon, 
  iconType = 'primary',
  change,
  changeType,
  className = '',
  children,
  ...props 
}) => {
  const cardStyles = getCardStyles();
  const titleStyles = getTextStyles('heading');
  const subtitleStyles = getTextStyles('muted');
  const valueStyles = getTextStyles('heading');
  const iconColor = getIconColor(iconType);

  return (
    <div 
      className={`p-6 ${className}`}
      style={cardStyles}
      {...props}
    >
      {/* Header with icon and title */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          {Icon && (
            <div 
              className="p-2 rounded-lg"
              style={{ 
                backgroundColor: iconType === 'success' ? '#e8f5e8' : '#e6f7fa',
                color: iconColor 
              }}
            >
              <Icon className="h-6 w-6" />
            </div>
          )}
          <div>
            {title && (
              <h3 className="text-lg font-semibold" style={titleStyles}>
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-sm" style={subtitleStyles}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Value and change indicator */}
      {value && (
        <div className="mb-4">
          <div className="text-2xl font-bold" style={valueStyles}>
            {value}
          </div>
          {change && (
            <div 
              className="text-sm font-medium flex items-center mt-1"
              style={{ 
                color: changeType === 'positive' ? PROCOGIA_COLORS.green : 
                       changeType === 'negative' ? PROCOGIA_COLORS.blue : 
                       PROCOGIA_COLORS.lightGrey 
              }}
            >
              {change}
            </div>
          )}
        </div>
      )}

      {/* Custom content */}
      {children}
    </div>
  );
};

export default ThemedCard; 